import React from "react";
import { PanelEditAdCategory } from "../../../UI/AdCategories/Edit/PanelEditCategory";

const EditAdCategory = () => {
  return (
    <div>
      <PanelEditAdCategory />
    </div>
  );
};

export default EditAdCategory;
